"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("@kbbcomponentlibrary/icon-base"));

/*eslint import/namespace: ['error', { allowComputed: true }]*/
var IconCheck = function IconCheck(props) {
  return _react["default"].createElement(_iconBase["default"], props, _react["default"].createElement("path", {
    d: "M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
  }));
};
IconCheck.displayName = 'IconCheck';
var _default = IconCheck;
exports["default"] = _default;
IconCheck.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "IconCheck",
  "props": {
    "size": {
      "required": true,
      "flowType": {
        "name": "number"
      },
      "description": ""
    },
    "viewBox": {
      "required": true,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "colorFill": {
      "required": true,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "children": {
      "required": false,
      "flowType": {
        "name": "ReactElement",
        "raw": "React.Element <*>",
        "elements": [{
          "name": "unknown"
        }]
      },
      "description": ""
    }
  }
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Check.js"] = {
    name: "IconCheck",
    docgenInfo: IconCheck.__docgenInfo,
    path: "src/Check.js"
  };
}